export default `
query licensePlates {
  wmLicensePlates {
    uid
    brand
    model
    info
    license_plate
  }
}`